import { useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { addProductQna, putProductQna } from '../../api/productQna'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'

export default function ProductQnaWrite() {
  const [content, setContent] = useState<string>('')
  const navigate = useNavigate()
  const location = useLocation()
  const { isAppView } = useAppContext()

  const queryParams = new URLSearchParams(location.search)
  const productNo = queryParams.get('productNo') || location.state?.productNo
  const productName = queryParams.get('productName') || location.state?.productName
  const brandName = queryParams.get('brandName') || location.state?.brandName
  const imgSrc = queryParams.get('imgSrc') || location.state?.imgSrc
  const prevContent = queryParams.get('prevContent') || location.state?.prevContent || ''
  const modify = queryParams.get('modify') || location.state?.modify || false
  const inquiryNo = queryParams.get('inquiryNo') || location.state?.inquiryNo || ''

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>상품 Q&A 작성</PageTitle>
            <div className='inquiry_write'>
              <div className='inquiry_write_box'>
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    paddingBottom: 24,
                    borderBottom: '1px solid #eaeaea',
                    marginBottom: 24,
                  }}
                >
                  <img
                    src={`${imgSrc}`}
                    alt=''
                    style={{
                      width: 56,
                      height: 56,
                      backgroundColor: 'rgba(0,0,0,0.03)',
                      borderRadius: '10px',
                    }}
                  />
                  <div>
                    <p
                      style={{
                        color: '#191919',
                        fontSize: 12,
                        fontWeight: '600',
                        lineHeight: '14px',
                      }}
                    >
                      {brandName}
                    </p>
                    <p
                      style={{
                        marginTop: 2,
                        color: '#191919',
                        fontSize: 14,
                        fontWeight: '500',
                        lineHeight: '18px',
                      }}
                    >
                      {productName}
                    </p>
                  </div>
                </div>

                <p
                  style={{
                    color: '#191919',
                    fontSize: '16px',
                    fontWeight: '700',
                    lineHeight: '24px',
                    marginBottom: 8,
                  }}
                >
                  상품에 대한 질문을 남겨주세요.
                </p>
                <TextAreaWrap>
                  <textarea
                    name=''
                    id=''
                    placeholder='내용을 입력해주세요.'
                    defaultValue={prevContent ? prevContent : content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                  <div className='button_wrap'>
                    <button
                      className='cancel_btn'
                      onClick={() => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.goBack)
                        } else {
                          navigate(-1)
                        }
                      }}
                    >
                      취소
                    </button>
                    <button
                      onClick={() => {
                        if (content === '') {
                          alert('내용을 입력해 주세요.')
                          return
                        }
                        if (productNo === '') {
                          alert('찾을 수 없는 상품입니다. 다시 시도해 주세요.')
                          return
                        }

                        if (modify) {
                          putProductQna({
                            type: 'OTHER',
                            title: '',
                            content: content ? content : '',
                            productNo: inquiryNo ? inquiryNo : '',
                          })
                            .then(() => {
                              const shareClick: DataLayerArgs = {
                                dataLayer: {
                                  event: 'inquire_complete',
                                  event_info: {
                                    item_id: String(location.state.productNo),
                                    item_name: location.state.productName,
                                  },
                                },
                              }

                              if (isAppView) {
                                sendSetAppsflyerEvent({
                                  eventName: 'inquire_complete',
                                  eventType: {
                                    item_id: String(location.state.productNo),
                                    item_name: location.state.productName,
                                  },
                                })
                                RNPostMessage(AFWebLinkType.goBack)
                              } else {
                                TagManager.dataLayer(shareClick)
                                navigate(-1)
                              }
                            })
                            .catch(() => {
                              alert('문의 등록에 실패했습니다. 다시 시도해 주세요.')
                            })
                        } else {
                          addProductQna({
                            type: 'OTHER',
                            title: '',
                            content: content ? content : '',
                            productNo: productNo ? productNo : '',
                          })
                            .then(() => {
                              const inquire: DataLayerArgs = {
                                dataLayer: {
                                  event: 'inquire_complete',
                                  event_info: {
                                    item_id: productNo,
                                    item_name: productName,
                                  },
                                },
                              }

                              if (isAppView) {
                                sendSetAppsflyerEvent({
                                  eventName: 'inquire_complete',
                                  eventType: {
                                    item_id: productNo,
                                    item_name: productName,
                                  },
                                })
                                RNPostMessage(AFWebLinkType.goBack)
                              } else {
                                TagManager.dataLayer(inquire)
                                navigate(-1)
                              }
                            })
                            .catch(() => {
                              alert('문의 등록에 실패했습니다. 다시 시도해 주세요.')
                            })
                        }
                      }}
                      type='submit'
                      className='submit_btn'
                    >
                      등록
                    </button>
                  </div>
                </TextAreaWrap>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const TextAreaWrap = styled.div`
  margin-top: 8px;
  & textarea {
    width: 100%;
    height: 208px;
    padding: 8px 16px;
    border: 1px solid var(--colGray3);
    border-radius: 5px;
    color: var(--colBlack);
    font-size: 14px;
    line-height: 24px;
    font-family: 'Pretendard', sans-serif;
    &:focus {
      border: 1px var(--colBlack) solid;
    }
  }
  & .filewrap {
    margin: 16px 0 8px 0;
    & ul {
      display: flex;
      gap: 10px;
      & li {
        position: relative;
        & input {
          padding: 0;
          font-size: 0;
          line-height: inherit;
          color: transparent;
          letter-spacing: 0;
          width: 0 !important;
          display: none;
        }
        & label {
          position: relative;
          display: block;
          width: 80px;
          height: 80px;
          border: 1px dashed var(--colGray4);
          background: var(--colGray1);
          border-radius: 8px;
          & div {
          }
          & span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
            height: 12px;
            background: url('../images/icon_plus2.svg') no-repeat;
            background-size: contain;
          }
        }
        & button {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          border: 0;
          width: 32px;
          height: 32px;
          background: url('../images/icon_clear_button.png') no-repeat;
          background-size: contain;
        }
      }
    }
  }
  & .button_wrap {
    margin-top: 24px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    text-align: center;
    & .cancel_btn {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colBlack);
      border: 1px solid var(--colGray3);
      border-radius: 5px;
      padding: 11px;
    }
    & .submit_btn {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colWhite);
      background: var(--colBlack);
      border: 0;
      border-radius: 5px;
      padding: 11px;
    }
  }
`
